module.exports = __webpack_public_path__ + "static/media/外卖.d3dd30d7.jpg";